import { Injectable } from '@angular/core';
import { BaseHttpService } from './base-http.service';
import { Observable } from 'rxjs';
import { buildQueryParams, idsQueryParamsBuilder } from '@shared/helpers';
import {
  ClassificationCodeDto,
  ClassificationDetailDto,
  ClassificationFolderDto,
  ClassificationSheetDto,
} from '@shared/interfaces/dtos/classifications';
import { ClassificationFoldersQuery } from '@shared/interfaces/classifications';

@Injectable({
  providedIn: 'root',
})
export class ClassificationsService extends BaseHttpService {
  protected endPoint: string = 'Global/Classements';

  public fetchClassificationForAService(serviceId: number): Observable<ClassificationDetailDto[]> {
    return this.http.get<ClassificationDetailDto[]>(
      this.buildURL({ idOrSubEndpoint: 'Search', apiScope: 'iAdmin', overrideEndPoint: 'Global/ClassementDossiers' }),
      {
        params: { SvcIds: serviceId, IncludePartages: true, ClasseurArchived: 'Exclude', ChemiseArchived: 'Exclude' },
      }
    );
  }

  public fetchClassificationCodes(servicesIds: number[]): Observable<ClassificationCodeDto[]> {
    return this.http.get<ClassificationCodeDto[]>(this.buildURL({ idOrSubEndpoint: 'Search', apiScope: 'iAdmin' }), {
      params: servicesIds.length ? { svcIds: idsQueryParamsBuilder(servicesIds) } : undefined,
    });
  }

  public fetchClassificationFolders(query?: ClassificationFoldersQuery): Observable<ClassificationFolderDto[]> {
    return this.http.get<ClassificationFolderDto[]>(
      this.buildURL({ idOrSubEndpoint: 'Classeurs', apiScope: 'iAdmin', overrideEndPoint: 'Global' }),
      {
        params: buildQueryParams(query),
      }
    );
  }

  public fetchClassificationSheets(folderId?: number): Observable<ClassificationSheetDto[]> {
    return this.http.get<ClassificationSheetDto[]>(
      this.buildURL({ idOrSubEndpoint: 'Chemises', apiScope: 'iAdmin', overrideEndPoint: 'Global' }),
      {
        params: folderId ? { ClasseurId: folderId } : undefined,
      }
    );
  }
}
